import { ScreenWidthEnum } from "@/enums";

const CONTAINER_SELECTOR = ".js-collapsible-content-container";
const CONTENT_SELECTOR = ".js-collapsible-content";
const ACTION_SELECTOR = ".js-toggle-collapsible-content";
const COLLAPSE_CLASS = "invisible";

const removeOthers = (selected: HTMLElement) => {
  for (const container of document.querySelectorAll(CONTAINER_SELECTOR)) {
    const content = container.querySelector(CONTENT_SELECTOR) as HTMLElement;

    if (!content || content === selected) {
      continue;
    }

    content.classList.add(COLLAPSE_CLASS);
  }
};

const toggleClass =
  (content: HTMLElement) =>
  (e: Event): void => {
    if (!content || !e.target) return;

    e.stopPropagation();
    e.preventDefault();

    removeOthers(content);
    content.classList.toggle(COLLAPSE_CLASS);
  };

const isTouchableDevice = () =>
  "ontouchstart" in window ||
  navigator.maxTouchPoints > 0 ||
  window.innerWidth < ScreenWidthEnum.IPAD_LANDSCAPE - 1;

export default (parent: HTMLElement | Document): void => {
  for (const container of parent.querySelectorAll(CONTAINER_SELECTOR)) {
    const content = container.querySelector(CONTENT_SELECTOR) as HTMLElement;
    const toggle = container.querySelector(ACTION_SELECTOR) as HTMLElement;
    const isOnlyMobile = (container as HTMLElement).dataset.onlyMobile;

    if (!content || !toggle || (!isTouchableDevice() && isOnlyMobile)) {
      continue;
    }

    toggle.addEventListener("click", toggleClass(content));
  }
};
